import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { AlertTriangle, Loader2 } from 'lucide-react'
import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { CsHealthBadge } from '@/components/Cs/CsHealthBadge'
import { useCsCarteiraPage } from '@/hooks/useCsCarteiraPage'
import { CS_PLANO_ACAO_STATUS } from '@/services/csService'

export default function CsRetencaoPage() {
  const { accounts, loading, setRiscoOnly } = useCsCarteiraPage()

  useEffect(() => {
    setRiscoOnly(true)
  }, [setRiscoOnly])

  return (
    <DashboardLayout title='Sucesso do Cliente — Retenção'>
      <div className='space-y-4'>
        <header>
          <h2 className='text-xl font-semibold text-text-primary'>Contas com risco de churn</h2>
          <p className='mt-2 max-w-3xl text-sm text-text-muted'>
            Motivo, plano de ação e status — priorize prevenção de churn.
          </p>
        </header>

        {loading && (
          <div className='flex h-40 items-center justify-center'>
            <Loader2 className='animate-spin text-[var(--brand-primary)]' size={28} />
          </div>
        )}

        {!loading && accounts.length === 0 && (
          <div className='glass-card p-8 text-center text-sm text-text-muted'>
            Nenhuma conta marcada com risco de churn no momento.
          </div>
        )}

        <ul className='space-y-3'>
          {accounts.map((acc) => {
            const name = acc.empresa.nomeFantasia || acc.empresa.razaoSocial || acc.empresa.nome || 'Cliente'
            const planoStatus = CS_PLANO_ACAO_STATUS.find((s) => s.value === acc.planoAcaoStatus)?.label
            return (
              <li key={acc.id} className='glass-card p-4'>
                <div className='flex flex-wrap items-start justify-between gap-3'>
                  <div>
                    <Link
                      to={`/cs/contas/${acc.id}`}
                      className='text-base font-semibold text-text-primary hover:text-accent'
                    >
                      {name}
                    </Link>
                    <p className='mt-1 text-sm text-text-muted'>{acc.deal.nome}</p>
                  </div>
                  <div className='flex flex-wrap items-center gap-2'>
                    <CsHealthBadge score={acc.healthScoreFinal ?? acc.healthScore} band={acc.healthBand} />
                    <span className='inline-flex items-center gap-1 rounded-md border border-rose-500/20 bg-rose-500/10 px-2 py-0.5 text-[10px] font-bold uppercase text-rose-400'>
                      <AlertTriangle size={10} /> Churn
                    </span>
                  </div>
                </div>
                <dl className='mt-3 grid gap-2 text-sm md:grid-cols-2'>
                  <div>
                    <dt className='text-xs text-text-muted'>Motivo</dt>
                    <dd className='text-text-primary'>{acc.riscoMotivo || '—'}</dd>
                  </div>
                  <div>
                    <dt className='text-xs text-text-muted'>Identificado em</dt>
                    <dd className='text-text-primary'>
                      {acc.riscoIdentificadoEm
                        ? new Date(acc.riscoIdentificadoEm).toLocaleDateString('pt-BR')
                        : '—'}
                    </dd>
                  </div>
                  <div>
                    <dt className='text-xs text-text-muted'>Plano de ação</dt>
                    <dd className='text-text-primary'>{acc.planoAcao || '—'}</dd>
                  </div>
                  <div>
                    <dt className='text-xs text-text-muted'>Status do plano</dt>
                    <dd className='text-text-primary'>{planoStatus || '—'}</dd>
                  </div>
                  <div>
                    <dt className='text-xs text-text-muted'>Responsável</dt>
                    <dd className='text-text-primary'>{acc.planoAcaoUser?.name || acc.csm?.name || '—'}</dd>
                  </div>
                </dl>
              </li>
            )
          })}
        </ul>
      </div>
    </DashboardLayout>
  )
}
